<template>
  <div class="items-end">
    <v-card shaped elevation="10" class="p-3" :loading="loading">
      <div class="flex flex-col mt-2">
        <div class="w-2/3 flex">
          <label class="flex flex-col w-1/2 pb-6 pr-3">
            <Lynx-Label label="Data Inicial" />
            <b-datepicker
              v-model="form.data_inicio"
              placeholder="Selecione uma data"
              :date-formatter="
                (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
              "
              :date-parser="(date) => new Date(date)"
              :month-names="monthNames"
              :day-names="dayNames"
              :years-range="[-20, 10]"
              icon="calendar-today"
              locale="pt-BR"
            />
          </label>
          <label class="flex flex-col w-1/2 pb-6 pr-3">
            <Lynx-Label label="Data Final" />
            <b-datepicker
              v-model="form.data_fim"
              placeholder="Selecione uma data"
              :date-formatter="
                (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
              "
              :date-parser="(date) => new Date(date)"
              :month-names="monthNames"
              :day-names="dayNames"
              icon="calendar-today"
              :years-range="[-20, 10]"
            />
          </label>

          <b-button
            style="margin-top: 30px"
            @click.native="fetchValues()"
            type="is-primary"
            >buscar</b-button
          >
          <b-button
            style="margin-top: 30px; margin-left: 10px"
            @click.native="clearDate()"
            type="is-warning"
            >Limpar Datas</b-button
          >
        </div>
      </div>

      <div v-if="dados" class="pt-5">
        <table style="font-size: 10px">
          <thead>
            <tr>
              <th></th>
              <th v-for="(mes, index) in meses" :key="index">
                <!-- {{mes}} -->
                {{
                  meses.length - 1 == index
                    ? mes
                    : meses.length - 2 != index
                    ? moment(mes, "DD/MM/YYYY")
                        .endOf("month")
                        .format("DD/MM/YYYY")
                    : moment(form.data_fim, "YYYY/MM/DD").format("DD/MM/YYYY")
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dados, tipo) in dadosPorTipo" :key="tipo">
              <td
                class="text-uppercase"
                width="125"
                :style="calculoCores(tipo)"
              >
                {{ tipo }}
              </td>

              <td
                class="text-uppercase makeBtn"
                :style="calculoCores(tipo)"
                v-for="mes in meses"
                :key="mes"
                style="cursor: pointer;"  @click="getEmpresasTab(tipo, mes)"
                :class="regra.tipo == tipo && regra.mes == mes ? 'makeBtnfixo' : ''"
              >
                <span >
                  {{ dados[mes] || 0 }}</span
                >
              </td>
            </tr>
            <tr style="background: #4af783; font-weight: 900">
              <td>Saldo</td>
              <td v-for="mes in meses" :key="mes">
                {{ calcularSaldo(mes) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>

    <h2 v-if="regra.tipo != null" class="text-lg md:text-base text-neutral-600 mt-5">
        {{ regra.tipo  }} -
        {{ regra.mes  }} 
      </h2>
       <b-table
       
          v-if="empresas"
          :columns="columns"
          :data="empresas"
          :per-page="perPage"
          :paginated="true"
          default-sort-direction="asc"
          default-sort="id"
          hoverables
          class="w-full rounded-t-none table-responsive mt-5"
          style="font-size: 12px"
        >
          <template v-slot="props">
            <b-table-column field="id" v-text="props.row.id" />
            <b-table-column field="razao_social" v-text="props.row.razao_social" />
       
            <b-table-column field="acoes">
              <v-btn icon color="success" @click.native="searchEmpresa(props.row)"
                ><v-icon>mdi-arrow-right-bold-circle-outline</v-icon></v-btn
              >
            
            </b-table-column>
          </template>
          <template #empty>
            <Not-Found-Data text="Nada foi seleciona na tabela" />
          </template>
        </b-table>
  </div>
</template>

<script>
// import PieChart from "@/components/Chart/PieChart";
// import { twColors, twFonts } from "@/services/tailwindConfig";
import NotFoundData from "@/components/layouts/NotFoundData";
import { ResumaoCompanies } from "@/services/requests/charts";
import { formatEnToBr } from "@/utils/momentHelpers";
// import bus from "@/services/bus";
import { empresasShowRequest } from "@/services/requests/empresas";
import moment from "moment";
import { dayNames, monthNames } from "@/utils/utils";
import { formatBrToEn } from "@/utils/momentHelpers";
import bus from "@/services/bus";

export default {
  name: "ResumoEmpresas",
  components: {  NotFoundData },
  data() {
    //  const dataAtual = new Date();
    // const dataInicio = subMonths(dataAtual, 11); // Subtrai 11 meses para obter os últimos 12 meses
    // const dataFim = dataAtual;
    return {
      header: {
        title: "Resumo Churn ",
      },
      dados: null,
      dayNames,
      monthNames,
      loading: false,
      empresas:[],
      regra:{tipo:null,mes:null},
      form: {
        data_inicio: new Date(moment().subtract(11, "months").startOf("month")),
        data_fim: new Date(),
      },
      currentPage: 1,
      perPage: 10,
      columns: [
        {
          field: "id",
          label: "id",
          sortable: true,
          searchable: true,
          width: 130,
          // numeric: true,
        },

        {
          field: "razao_social",
          label: "Razao Social",
          sortable: false,
          searchable: true,
        },
        {
          field: "acoes",
          label: "Ações",
        },

      ]
    };
  },
  filters: {
    formatEnToBr,
  },
  watch: {
    "form.data_inicio": function (newValue) {
      const newEndDate = new Date(moment(newValue).add(11, "months"));

      // Mantenha o mesmo dia do mês
      newEndDate.setDate(this.form.data_fim.getDate());

      if (this.form.data_fim.getTime() !== newEndDate.getTime()) {
        this.form.data_fim = newEndDate;
      }
    },
    "form.data_fim": function (newValue) {
      const newStartDate = new Date(moment(newValue).subtract(11, "months"));

      // Mantenha o mesmo dia do mês
      newStartDate.setDate(this.form.data_inicio.getDate());

      if (this.form.data_inicio.getTime() !== newStartDate.getTime()) {
        this.form.data_inicio = newStartDate;
      }
    },
  },

  computed: {
    meses() {
      return this.dados.meses;
    },
    dadosPorTipo() {
      return this.dados.dados;
    },
    empresasPorTipo() {
      return this.dados.dados_empresas;
    },
  },
  methods: {
    moment,
    calculoCores(tipo) {
      switch (tipo) {
        case "Numero de clientes":
          return "background:#87cefa; font-weight:900";

        default:
          break;
      }
    },
    calcularSaldo(mes) {
      let saldo = 0;

      for (const tipo in this.dadosPorTipo) {
        const valor = this.dadosPorTipo[tipo][mes] || 0;



        if (tipo.includes("Empresas Finalizadas")) {
          saldo += valor;
        } else if (tipo.includes("Descongeladas")) {
          saldo += valor;
        } else if (
          tipo.includes("Congeladas") ||
          tipo.includes("Encerramento") ||
          tipo.includes("Transferência outro contador") ||
          tipo.includes("Baixa da empresa") ||
          tipo.includes("Outros")

        ) {
          saldo -= valor;
        }

      }

      return saldo;
    },
    searchEmpresa(empresa) {
      bus.globalLoading = true;
      empresasShowRequest(empresa.id)
        .then((res) => {
          this.$store.dispatch("setEmpresa", res.data.data);
          this.$router.push({ name: "empresas.show" });
        })
        .catch(() => this.$snack.error("Empresa não encontrada"))
        .finally(() => (bus.globalLoading = false));
    },

    clearDate() {
      this.form = {
        data_inicio: null,
        data_fim: null,
      };
      
    },
    async fetchValues() {
      this.loading = true;
      let a = {
        data_inicio: formatBrToEn(this.form.data_inicio),
        data_fim: formatBrToEn(this.form.data_fim),
      };
      await ResumaoCompanies(a)
        .then((res) => {
          this.dados = res.data;
        })
        .finally(() => (this.loading = false));
      // console.log([this.values.datasets[0].data.series]);
    },
    getEmpresasTab(tipo, mes) {
      this.regra = {tipo:tipo,mes:mes}

    this.empresas = this.empresasPorTipo[tipo][mes]
    },
  },
  mounted() {
    this.fetchValues();
  },
};
</script>

<style scoped>
.makeBtn{
  transition: font-size 0.3s ease;

}
.makeBtn:hover{
  background: #0d032c;
  color: white;
}
.makeBtnfixo{
  background: #0d032c;
  color: white;
}
</style>
